import { z } from "zod";

export const createEnderecoSnapshotSchema = z.object({
  nome: z.string().max(64, "Nome deve ter no máximo 64 caracteres"),
  telefone: z.string().max(11, "Telefone deve ter no máximo 11 caracteres"),
  latitude: z.number(),
  longitude: z.number(),
  estado: z.string().max(32, "Estado deve ter no máximo 32 caracteres"),
  cidade: z.string().max(32, "Cidade deve ter no máximo 32 caracteres"),
  logradouro: z
    .string()
    .max(128, "Logradouro deve ter no máximo 128 caracteres"),
  bairro: z.string().max(64, "Bairro deve ter no máximo 64 caracteres"),
  numero: z.string().max(8, "Número deve ter no máximo 8 caracteres"),
  referencia: z
    .string()
    .max(64, "Referência deve ter no máximo 64 caracteres")
    .optional(),
});

export const enderecoSnapshotResponseSchema = z.object({
  id: z.number(),
  userId: z.number(),
  nome: z.string(),
  telefone: z.string(),
  latitude: z.string(),
  longitude: z.string(),
  estado: z.string(),
  cidade: z.string(),
  logradouro: z.string(),
  bairro: z.string(),
  numero: z.string(),
  referencia: z.string().nullable().optional(),
  createdAt: z.string(),
});

export type CreateEnderecoSnapshotDto = z.infer<
  typeof createEnderecoSnapshotSchema
>;
export type EnderecoSnapshotResponseDto = z.infer<
  typeof enderecoSnapshotResponseSchema
>;
